export function getObjectItemByNumber(number) {
    return function (dispatch, getState) {
        let result = null;
        for (let i = 0; i < getState().objectManagementState.objectgroups.length; i++) {
            const group = getState().objectManagementState.objectgroups[i];
            for (let j = 0; j < group.ObjectItems.length; j++) {
                const item = group.ObjectItems[j];
                if (item.ItemNumber === number) {
                    result = item;
                    break;
                }
            }

            if (result !== null) {
                break;
            }
        }

        return result;
    }
}

export function getObjectItem(objectItemId) {
    return function (dispatch, getState) {
        let result = null;
        for (let i = 0; i < getState().objectManagementState.objectgroups.length; i++) {
            const group = getState().objectManagementState.objectgroups[i];
            for (let j = 0; j < group.ObjectItems.length; j++) {
                const item = group.ObjectItems[j];
                if (item.ObjectItemId === objectItemId) {
                    result = item;
                    break;
                }
            }

            if (result !== null) {
                break;
            }
        }

        return result;
    }
}
export function getObjectItemByXY(x, y, width, height) {
    return function (dispatch, getState) {

        const orgStartX = x;
        const orgEndX = x + (width - 1);
        const orgStartY = y;
        const orgEndY = y + (height - 1);

        //console.log(`X: ${orgStartX},${orgEndX} || Y: ${orgStartY},${orgEndY}`);

        const selectedGroup = getState().objectManagementState.selectedobjectgroup;
        let result = null;
        for (let i = 0; i < getState().objectManagementState.objectgroups.length; i++) {
            const group = getState().objectManagementState.objectgroups[i];
            if (group.ObjectGroupId === selectedGroup) {
                for (let j = 0; j < group.ObjectItems.length; j++) {
                    const item = group.ObjectItems[j];

                    const startX = item.LocationX;
                    const endX = item.LocationX + (item.Width - 1);

                    const startY = item.LocationY;
                    const endY = item.LocationY + (item.Height - 1);
                    
                    //console.log(`Item: ${item.ObjectItemId} || X: ${startX}, ${endX} || Y: ${startY},${endY}`);

                    // if (x >= startX && y <= endX
                    //     && y >= startY && y <= endY) {
                    //     result = item;
                    //     break;
                    // }

                    if (orgStartX <= endX
                        && orgEndX >= startX
                        && orgStartY <= endY
                        && orgEndY >= startY) {
                        result = item;
                        break;
                    }
                }
            }

            if (result !== null) {
                break;
            }
        }

        return result;
    }
}

export function getSystemUser(systemUserId) {
    return function (dispatch, getState) {
        let result = null;
        for (let i = 0; i < getState().loginState.users.length; i++) {
            const user = getState().loginState.users[i];
            if (user.SystemUserId === systemUserId) {
                result = user;
                break;
            }
        }

        return result;
    }
}

export function getLoggedInId(sytemUserId)
{
    return function (dispatch, getState){
        if(getState().loginState.loggedin.id === sytemUserId)
            return true;
        else
        return false;
    }
}
export function getArticle(articleId) {
    return function (dispatch, getState) {
        let result = null;
        for (let i = 0; i < getState().generalState.articles.length; i++) {
            const article = getState().generalState.articles[i];
            if (article.ArticleId === articleId) {              
                result = article;
                break;
            }
        }
        return result;
    }
}
export function getArticleDescription(article) {
    return function (dispatch, getState) {
        if (article === null || article === undefined) {
            return '';
        }

        const culture = getState().layoutState.language.culture;

        if (article.Translations && article.Translations.length > 0) {
            const translation = article.Translations.find(x => x.Culture && x.Culture.toLowerCase().substring(0, 2) === culture);
            if (translation && translation.Description) {
                return translation.Description;
            }
        }

        //No translation for the selected language, so fall back to the default description of the article.
        return article.Description;
    }
}
export function getPos(posId) {
    return function (dispatch, getState) {
        let result = null;
        for (let i = 0; i < getState().generalState.posList.length; i++) {
            const pos = getState().generalState.posList[i];
            if (pos.PosId === posId) {
                result = pos;
                break;
            }
        }
        return result;
    }
}
export function getArticleConfigurationStepValue(configurationStepId, configurationStepValueId) {
    return function (dispatch, getState) {
        let result = null;

        for (let i = 0; i < getState().generalState.configurationsteps.length; i++) {
            const configurationStep = getState().generalState.configurationsteps[i];
            if (configurationStep.ArticleConfigurationStepId === configurationStepId) {
                for (let j = 0; j < configurationStep.ArticleConfigurationStepValues.length; j++) {
                    const configurationStepValue = configurationStep.ArticleConfigurationStepValues[j];
                    if (configurationStepValue.ArticleConfigurationStepValueId === configurationStepValueId) {
                        result = configurationStepValue;
                        break;
                    }
                }
            }

            if (result !== null) {
                break;
            }
        }

        return result;
    }
}

export function getPayment(paymentId) {
    return function (dispatch, getState) { // => getState().generalState.paymentMethod.all.find(method => method.PaymentId === paymentId);
        const state = getState();

        let result = null;
        for (let i = 0; i < state.generalState.paymentMethod.all.length; i++) {
            const paymentMethod = state.generalState.paymentMethod.all[i];
            if (paymentMethod.PaymentId === paymentId) {
                result = paymentMethod;
                break;
            }
        }
        return result;
    }
}

export function getPriceList(priceListId) {
    return function (dispatch, getState) {
        let result = null;
        for (let i = 0; i < getState().generalState.pricelists.length; i++) {
            const priceList = getState().generalState.pricelists[i];
            if (priceList.PriceListId === priceListId) {
                result = priceList;
                break;
            }
        }
        return result;
    }
}

export function getTranslation(key) {
    return function (dispatch, getState) {
        let result = key;
        
        const currentCulture = getState().layoutState.language.culture;
        switch (currentCulture) {
            case 'nl':
                result = getState().layoutState.language.dutch[key];
                break;
            case 'en':
                result = getState().layoutState.language.english[key];
                break;
            case 'fr':
                result = getState().layoutState.language.french[key];
                break;
            case 'de':
                result = getState().layoutState.language.german[key];
                break;
            default:
                break;
        }

        if (!result) {
            result = key;
        }

        return result;
    }
}


// WEBPACK FOOTER //
// src/actions/dataActions.js